
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-07e1fb6b&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./SemipolarSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./SemipolarSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-07e1fb6b!../../../../vue-loader/lib/selector?type=template&index=0!./SemipolarSpinner.vue"),
  /* scopeId */
  "data-v-07e1fb6b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/SemipolarSpinner.vue
// module id = 873
// module chunks = 1